import { styled } from "@mui/material";
import {RouteResponse} from '../../../../types/index';
import {FetchAllRoutes, reOrderFetchedData, filterRouteName} from '../../../../hooks/FetchData'

interface ComponentProps {
    startDate: string;
    endDate: string;
    year: number;
    status: boolean;
    routeId: number;
}



const ApplicationPeriodDetails: React.FC<ComponentProps> = ({startDate, endDate, year, status, routeId})  => {

    const {data} = FetchAllRoutes();

    const reOrderedAllRoutes = data ? reOrderFetchedData((data as RouteResponse )?.Data) : []


     

    return (
        <>
            <StyledContainer>
                <StyledWrapper>
                    <StyledText>Route Name</StyledText>
                    <StyledDate>{filterRouteName(routeId, reOrderedAllRoutes)}</StyledDate>
                </StyledWrapper>
                <StyledWrapper>
                    <StyledText>Status</StyledText>
                    {status === true ? (
                        <Active>Active</Active>
                    ) : (
                        <Inactive>Inactive</Inactive>
                    )} 
                </StyledWrapper>
                <StyledWrapper>
                    <StyledText>Start Date</StyledText>
                    <Active>{startDate}</Active>
                </StyledWrapper>
                <StyledWrapper>
                    <StyledText>End Date</StyledText>
                    <Active>{endDate}</Active>
                </StyledWrapper>
                <StyledWrapper>
                    <StyledText>Year</StyledText>
                    <StyledDate>{year}</StyledDate>
                </StyledWrapper>
            </StyledContainer>
        </> 
    );
};

export default ApplicationPeriodDetails;

const StyledContainer = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding-block-start: 1.8rem;
    padding-block-end: 5rem;
    padding-inline: 2rem;
`

const StyledWrapper = styled('div')`
    display: flex;
    justify-content: space-between;
`

const DetailText = styled('span')`
    font-weight: 600;
    font-size: 1.6rem;
    margin-inline: 0.8rem;
    margin-block-start: 2rem;
    margin-inline-start: 2rem;
`

const StyledText = styled('span')`
    font-size: 24px;
    font-weight: 400;
    color: #4E5A62;
`

const Active = styled('span')`
    font-size: 16px;
    font-weight: 500;
    background-color: #E0FAEE;
    border-radius: 0.4rem;
    padding-inline: 2rem;
    padding-block: 0.5rem;
    color: #11643C;
`

const Inactive = styled(Active)`
    background-color: #FAE0E0;
`

const StyledDate = styled(StyledText)`
    color: #020D08;
    font-weight: 500;
`